export default function hasItems<T>(array: Maybe<T[]>): array is T[] {
  return Array.isArray(array) && array.length > 0;
}
